<template>
  <Modal v-model="importModal" :title="importTitle" :transfer="false" :mask-closable="false" :width="modalWidth"
    @on-visible-change="importModalChange">
    <Form ref="importSalesPriceForm" :label-width="100" @submit.native.prevent>
      <Row align="middle" justify="space-between">
        <Col span="24" class="no_margin_style mb10" v-if="importType === 'YmsStock'">
          <Form-item :label="`${configCharacters()}` + $t('key1000333')">
            <Select filterable style="width: 200px" v-model="ymsWarehouseId" @on-change="updateParameter">
              <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col span="24" class="no_margin_style">
          <Form-item :label="$t('key1000262')" prop="file" class="required_style_label">
            <div class="flex align-items-center mb20">
              <Upload
                style="display: inline-block"
                :headers="headObj"
                ref="uploadRef"
                :name='fileName'
                :data="uploadData"
                :show-upload-list="false"
                :action="uploadAction"
                :before-upload="beforeHandleUpload"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :on-format-error="handleFormatError"
                :max-size="uploadFilesMaxSize"
                :format="importFormat">
                <Button class="mr10">
                  <i class="iconfont" v-if="system==='distributor'">&#xe664;</i>
                  <i class="iconfont" v-else>&#xe663;</i>
                  {{ $t('key1000266') }}
                </Button>
              </Upload>
              <div class="cursor ml20" :class="system === 'distributor' ? 'distributorThemeColor' : 'themeColor'" @click="download">{{ $t('key1000264') }}</div>
            </div>
          </Form-item>
        </Col>
        <Col span="20" class="no_margin_style mb10" v-if="excleFile">
          <Form-item :label="$t('key1000334')">
            <span>{{ excleFile.name }}</span>
          </Form-item>
        </Col>
        <Col span="24" class="no_margin_style mb10" v-if="importType === 'privateWarehouse'">
          <FormItem :label="$t('key1000335')" class="required_style_label">
            <Select v-model="warehouseId" filterable class="width_250" @on-change="updateParameter">
              <Option v-for="item in productShippingWarehouseData" :value="item.ymsWarehouseId" :label="item.name + ' (' + item.warehouseTypeName + ')'">
                <div class="flex align-items-center justify-content-between" style="width: 95%;">
                  <span class="color-333">{{ item.name }}</span>
                  <span class="font-size-12 color-999">{{ item.warehouseTypeName }}</span>
                </div>
              </Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="23" push="1" class="no_margin_style" v-if="importTypeList.includes(importType)">
          <Form-item :label="$t('key1000336')" :label-width="120" class="radio_styles">
            <RadioGroup v-model="existence" v-if="['Location', 'LogisticsBill'].includes(importType)" @on-change="updateParameter">
              <Radio :label="0">{{ $t('key1000269') }}</Radio>
              <Radio :label="1">{{ $t('key1000337') }}</Radio>
            </RadioGroup>
            <RadioGroup v-model="isCover" v-if="importType === 'YmsStock'" @on-change="updateParameter">
              <Radio :label="1">{{ $t('key1000268') }}</Radio>
              <Radio :label="0">{{ $t('key1000338') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <Col :span="promptPushSpan" :push="promptPush">
          <div class="tips_styles">
            <slot></slot>
          </div>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="importModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="saveImport">{{ importOKText }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import {getBatchSupplierWarehouseData, getImportTemplate, setConfigCharacters} from "@/utils/common";
import {endLoading, startLoading} from "@/utils/loading";
import api from '@/api/';
import {publicExceptionCodes} from "@/config/exceptionCode";
import {dynamicErrorCodeFun} from "@/utils/dynamicErrorCode";

export default {
  name: "commonImportModal",
  mixins: [Mixin],
  props: {
    // 导入的标题
    importTitle: {
      type: String,
      default: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000329')
    },
    // 导入的接口
    uploadAction: {
      type: String,
      default: null
    },
    // 导入的文件格式
    importFormat: {
      type: Array,
      default: () => {
        return ['xls', 'xlsx', 'csv'];
      }
    },
    // 导入按钮文本
    importOKText: {
      type: String,
      default: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111')
    },
    // 下载导入模板的key
    importTemplateKey: {
      type: String,
      default: ''
    },
    // 导入的默认参数 是 excleFile
    fileName: {
      type: String,
      default: 'excleFile'
    },
    // 上传需要的参数
    parameter: {
      type: Object,
      default: () => {
        return {};
      }
    },
    modalWidth: {
      type: Number,
      default: 600
    },
    promptPush: {
      type: Number,
      default: 4
    },
    promptPushSpan: {
      type: Number,
      default: 18
    },
    // 导入数据的处理方式
    /**
     * 运营系统->库位管理-->导入库位：Location
     * 运营系统->库存余量-->导入库存：YmsStock
     * 供应商系统->（库存余量--> 自有仓库导入Excel、商品管理---> 导入库存）：privateWarehouse
     * 运营系统-->财务管理-->物流账单--> 导入物流账单：LogisticsBill
     * 运营系统-->yms订单--> 实重导入：realWeightImport
     */
    importType: {
      type: String,
      default: ''
    },
    // 仓库下拉的基础数据
    warehouseList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      importTypeList: ['Location', 'YmsStock', 'LogisticsBill'],
      importModal: false,
      excleFile: null, // 导入的文件
      existence: 0, // 忽略、更新
      ymsWarehouseId: null, // 云卖仓库
      isCover: 1, // 库存余量-->导入库存，导入的数据已存在时默认覆盖数据
      uploadData: {}, // 上传时附带的额外参数
      formatError: false,
      warehouseId: null,
      productShippingWarehouseData: [],
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 上传文件之前
    beforeHandleUpload(excleFile) {
      let v = this;
      v.excleFile = excleFile;
      v.updateParameter();
      return false;
    },
    // 动态更新参数
    updateParameter() {
      let v = this;
      let obj = {};
      // 供应商系统->库存余量--> 自有仓库导入Excel
      if (v.importType === 'privateWarehouse') {
        obj.warehouseId = v.warehouseId;
      }
      // 运营系统->库存余量-->导入库存
      if (v.importType === 'YmsStock') {
        obj.isCover = v.isCover;
        obj.ymsWarehouseId = v.ymsWarehouseId;
      }
      /**
       * 运营系统-->库位管理-->库位导入
       * 运营系统-->财务管理-->物流账单--> 导入物流账单
       */
      if (['Location', 'LogisticsBill'].includes(v.importType)) {
        obj.importType = v.existence;
      }
      // 运营系统-->yms订单--> 实重导入
      if (v.importType === 'realWeightImport') {

      }
      v.uploadData = Object.assign({}, obj);
    },
    // 上传文件失败
    uploadError() {
      let v = this;
      v.formatError = true;
      v.importModal = true;
      v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000250'));
      setTimeout(() => {
        v.formatError = false;
      }, 2000);
      return false;
    },
    // 上传文件格式异常
    handleFormatError() {
      let v = this;
      v.formatError = true;
      v.importModal = true;
      v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000140'));
      setTimeout(() => {
        v.formatError = false;
      }, 2000);
      return false;
    },
    // 上传文件成功
    uploadSuccess(res, file, fileList) {
      let v = this;
      let code = res.code;
      if (code === 0) {
        v.importModal = false;
        let data = res.datas;
        if (data) {
          if (Array.isArray(data)) {
            if (data.length > 0) {
              endLoading();
              v.$Modal.warning({
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
                content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000327')}${data.join('、')}`,
                okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000248')
              });
            } else {
              handleSuccess();
            }
          } else {
            handleSuccess();
          }
        } else {
          handleSuccess();
        }

        function handleSuccess() {
          endLoading();
          v.$Message.success({
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251'),
            duration: 3
          });
          setTimeout(() => {
            v.$emit('updateData', true);
          }, 2000);
        }
      } else {
        // 优先匹配动态错误信息，其次匹配常规错误信息
        const text = dynamicErrorCodeFun(res) || publicExceptionCodes(code);
        v.$Message.error(text);
        v.importModal = false;
        return false;
      }
    },
    // 模板下载
    download() {
      if (this.importTemplateKey) {
        if (this.importTemplateKey === 'batchPriceAdjustment') {
          this.axios.get(api.get_productGoods_priceImportTemplate).then(res => {
            if (res.data.code === 0) {
              let url = res.data.datas;
              if (url) {
                window.open(url, '_self');
                setTimeout(() => {
                  this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000256'));
                }, 1500)
              }
            }
          });
        } else {
          getImportTemplate(this.importTemplateKey);
        }
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000331'));
        return false;
      }
    },
    // 导入的确定按钮
    saveImport() {
      let v = this;
      v.importModal = true;
      v.updateParameter();
      switch (v.importType) {
        case 'YmsStock':
          if (!v.ymsWarehouseId) {
            this.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000101')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328')}`);
            return false;
          }
          handleData();
          break;
        case 'privateWarehouse':
          if (!v.warehouseId) {
            this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000332'));
            return false;
          }
          handleData();
          break;
        default:
          handleData();
      }

      function handleData() {
        if (v.excleFile) {
          v.$refs['uploadRef'].post(v.excleFile); // 手动上传
          startLoading(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247'));
          if (!v.formatError) {
            setTimeout(() => {
              endLoading();
              v.excleFile = null;
              v.importModal = false;
            }, 2000);
          }
        } else {
          endLoading();
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000254'));
          return false;
        }
      }
    },
    // 关闭弹窗重置数据
    reset() {
      this.excleFile = null;
      this.existence = 0;
      this.ymsWarehouseId = null;
      this.isCover = 1;
      this.uploadData = {};
      this.warehouseId = null;
    },
    // 监听导入的弹窗
    importModalChange(value) {
      if (value) {
        switch (this.importType) {
          case 'YmsStock':
            if (this.warehouseList.length > 0) {
              this.ymsWarehouseId = this.warehouseList[0].ymsWarehouseId;
            }
            break;
          case 'privateWarehouse':
            getBatchSupplierWarehouseData([this.userInfo.merchantId]).then((newList) => {
              this.productShippingWarehouseData = this.uniqueFunc(newList, 'ymsWarehouseId');
            });
            break;
        }
      } else {
        this.reset();
      }
    }
  },
  watch: {
    formatError: {
      handler(value) {
        if (value) {
          endLoading();
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.no_margin_style {
  /deep/ .ivu-form-item {
    margin: 0 !important;
  }
}

.tips_styles {
  color: #9a9797;
  margin: 12px 0 20px 0;
}
</style>
